module.exports = __webpack_public_path__ + "static/media/undraw_questions_75e0.a8c58af6.svg";